import fetch from "./fetch";
/**
 * 讲师管理
 */
const expert = {
  //科室模糊查询
  remoteSearchChannel(params) {
    return fetch({
      isLoading: true,
      url: "/v1/department/selectByName",
      method: "GET",
      params,
    });
  },
  //职称模糊查询
  remoteSearchTitle(params) {
    return fetch({
      isLoading: true,
      url: "/professionalTitle/selectByName",
      method: "GET",
      params,
    });
  },
  //分页查询
  selectExpertList(params) {
    return fetch({
      isLoading: true,
      url: "/specialist/page",
      method: "GET",
      params,
    });
  },
  //新增
  addExpert(data) {
    return fetch({
      isLoading: true,
      url: "/specialist/save",
      method: "POST",
      data,
    });
  },
  //编辑
  editExpert(data) {
    return fetch({
      isLoading: true,
      url: "/specialist/update",
      method: "POST",
      data,
    });
  },
  //分页查询
  selectExpertRemote(params) {
    return fetch({
      isLoading: true,
      url: "/specialist/selectByName",
      method: "GET",
      params,
    });
  },
};

export default expert;
